import React from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Helmet } from 'react-helmet-async';
import { ParagraphRegular } from './Paragraph';
import { ReactComponent as GSLogo } from '../assets/images/Logo/GS-main-logo.svg';
import GbiDirectLogo from '../assets/images/Logo/GBI_Direct_Primary_Logo_250x74.png';

import Paragraph from './Paragraph/Paragraph';
import { variables } from '../assets/styles/variables';
import { retrieveFromSessionStorage } from '../util/helpers/sessionStorageHelper';
import { BROKER_CODE } from '../constants/sessionStorage';
import themeColors from '../assets/styles/themeColors';
import SectionLoader from './SectionLoader/SectionLoader';

const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;

  @media only screen and (max-width: 500px) {
    padding: 20px;
  }
`;

const GbiDirectLogoStyled = styled.img`
  width: auto;
  height: auto;
`;

const GSLogoStyled = styled(GSLogo)`
  width: 144px;
  height: 28px;
  background-color: ${themeColors.colorBorderPrimary};
  border-radius: 2px;
  padding: 4px;
`;

const TextContainer = styled.div`
  margin-top: 10px;
  max-width: ${variables.params.welcomeContentWidth};
  text-align: center;
`;

const quoteLogos = (BrokerCode) => {
  switch (BrokerCode) {
    case 'HAA':
      return () => <GbiDirectLogoStyled src={GbiDirectLogo} alt="Loader" />;
    case 'GS':
      return GSLogoStyled;
    default:
      return SectionLoader;
  }
};

const LoadingMessage = ({ BrokerCode }) => {
  const { t } = useTranslation();
  const brokerCode = BrokerCode ?? retrieveFromSessionStorage(BROKER_CODE);
  const LogoStyled = quoteLogos(brokerCode);

  return (
    <InnerContainer>
      <Helmet>
        <title>{t('loading')}</title>
      </Helmet>
      <LogoStyled />

      <TextContainer>
        <ParagraphRegular>{t('loginFluent.theQuote')}</ParagraphRegular>
      </TextContainer>
      <TextContainer>
        <Paragraph>{t('loginFluent.theQuoteAuthor')}</Paragraph>
      </TextContainer>
    </InnerContainer>
  );
};

LoadingMessage.propTypes = {
  BrokerCode: PropTypes.string,
};

export default LoadingMessage;
